import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import BlogCard from './BlogCard';
import { useSelector } from 'react-redux';
import AppTitle from '../../../layouts/AppTitle';
import { blogBg } from '../../../../assets/images';
import { useParams } from 'react-router-dom';

const BlogDetails = () => {
  const { id } = useParams();
  const blogs = useSelector(state => state?.products?.blogs);
  const myDivRef = useRef(null);

  const [blog, setBlog] = useState({});

  useEffect(() => {
    if (id) {
      const findBlog = blogs.find(b => b._id === id);
      setBlog(findBlog);
    } else {
      setBlog(blogs[0]);
    }
  }, [id]);

  useEffect(() => {
    scrollToProducts();
  }, []);

  function scrollToProducts() {
    if (myDivRef.current) {
      myDivRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const pageTitle = blog?.title ? `${blog.title}` : 'Blog Details';
  const pageDescription =
    blog?.shortDescription ??
    'Read this detailed blog from SayCheeze Cakes about cakes, desserts, and celebrations.';

  const imageUrl = blog?.files?.[0]?.path;
  const canonicalUrl = id
    ? `https://www.saycheezecakes.com/blog/${id}`
    : 'https://www.saycheezecakes.com/blog';

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name='description' content={pageDescription} />
        {imageUrl && <meta property='og:image' content={imageUrl} />}
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <AppTitle title='Blogs' from='Blog' link='/' to='Details' bgImg={blogBg} />

      <div class='blog-sidebar blog-sidebar-right' ref={myDivRef}>
        <div class='container'>
          <div class='row'>
            <div class='col-12 section-padding-04 order-1 order-lg-2'>
              <BlogCard blog={blog} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
